import { injectCardsListWidget } from './inject'
import './styles.css'

declare global {
  interface Window {
    HulyoCardsListWidget: {
      init: typeof injectCardsListWidget
    }
  }
}

window.HulyoCardsListWidget = {
  init: injectCardsListWidget,
}

// Auto-initialize if container exists
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    injectCardsListWidget()
  })
} else {
  injectCardsListWidget()
}

export { injectCardsListWidget }
